import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";

import { Link, useNavigate } from "react-router-dom";

import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from '../../../../../context/UserContext';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import HtlAgnOffPremises from "./HtlAgnOffPremises";
//import HtlPeriods from "./HtlPeriods";

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';




const GET_POST = gql`
query MyQuery(
    $rulPernId: Int
    $rulSubId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    ) {
        tbl_rules_sub(where: {
        r_prn_id_seq: {_eq: $rulPernId}
        id_seq: { _eq: $rulSubId }
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
    }) {
    id_seq
    r_prn_id_seq
    firm_main_code
    firm_sub_code
    rules_sub_type
    rules_sub_name
    start_date
    end_date
    status   
    active

  }
  tbl_rules_sub_premises(where: {
              r_sub_id_seq: {_eq: $rulSubId}}) {
    id_seq
    r_prn_id_seq   
    r_sub_id_seq 
    firm_main_code
    firm_sub_code
    start_date_v1
    end_date_v1
    start_date_v2
    end_date_v2
    opr_1
    opr_2
    pre_type
    
  }
  
}
`;




const INSERT_SEA = gql`
  mutation InsertRules(
    $rulPernId: Int
    $rulSubId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    $rulesName: String   
    $ruleType: String
    $startDate: date
    $endDate: date
    $fmActive: Boolean

   
    
  ) {
    insert_tbl_rules_sub(
      objects: {
        firm_main_code: $ownFirmCode,
        firm_sub_code: $ownFirmSubCode,
        r_prn_id_seq: $rulPernId,
        id_seq: $rulSubId,
        rules_sub_type: $ruleType,
        rules_sub_name: $rulesName,
        start_date: $startDate,
        end_date: $endDate,
        active: $fmActive,
       

        
      }
    ) {
      affected_rows
    }
  }
`;


const GET_RULES_CLS = gql`
  query MyQuery( $lang: String, $defType: String, $ruleClass2: String) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
        opt_1: { _eq: $ruleClass2 },
       
      }
    ) {
      lang
      type
      code
      name
      opt_1
    }
  }
`;



const UPDATE_RULES = gql`
mutation UpdateRules(
    $rulPernId: Int
    $rulSubId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    $rulesName: String   
    $ruleType: String
    $startDate: date
    $endDate: date
    $fmActive: Boolean
    
  ) {
    update_tbl_rules_sub(
      where: {
        id_seq: { _eq: $rulSubId }
        r_prn_id_seq: { _eq: $rulPernId }
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
      }
      _set: {
        
        rules_sub_type: $ruleType
        rules_sub_name: $rulesName
        active: $fmActive
        start_date: $startDate
        end_date: $endDate
      }
    ) {
      affected_rows
    }
  }
`; 

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;






const HtlAgnOffresEdit = () => {

   const {varCode, setVarCode} = useContext(ThemeContext);
   const {varCode2, setVarCode2} = useContext(ThemeContext);
   const {varCode8, setVarCode8} = useContext(ThemeContext);
   const {varCode9, setVarCode9} = useContext(ThemeContext);
   const {varCode10, setVarCode10} = useContext(ThemeContext);
   const {varCode11, setVarCode11} = useContext(ThemeContext);
   const {varCode12, setVarCode12} = useContext(ThemeContext);
  const {userName, setUserName} = useContext(ThemeContext);
  const { users } = useContext(UserContext);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;
  

  const lang = users.userLang;

 

  

     
   
  
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { rulPernId: varCode, ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode, rulSubId: varCode8  },
  });


  const firmData = data && data.tbl_rules_sub ? data.tbl_rules_sub[0] : null;
  const firmData2 = data && data.tbl_rules_sub_premises ? data.tbl_rules_sub_premises[0] : null;
 

  const [updateRulesSub] = useMutation(UPDATE_RULES);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 
  const [InsertSeason] = useMutation(INSERT_SEA);

  const [displayBasic, setDisplayBasic] = useState(false);

  
  
  
 // const [firmCode, setFirmcode] = useState(firmData ? firmData.firm_main_code_n : "");
 const [firmCode, setFirmCode] = useState('');
 const [firmName, setFirmName] = useState(""); 
 const [rulSubId, setRulSubnId] = useState(firmData ? firmData.id_seq : "");  
  const [rulPernId, setRulPernId] = useState(firmData ? firmData.r_prn_id_seq : ""); 
  const [rulesName, setRulesName] = useState(firmData ? firmData.rules_sub_name : ""); 
  const [ruleType, setRulesType] = useState(firmData ? firmData.rules_sub_type : ""); 
  const [fmActive, setFmActive] = useState(firmData ? firmData.active : false);   
  const [startDate, setStartDate] = useState(firmData ? new Date(firmData.start_date): new Date());
  const [endDate, setEndDate] = useState(firmData ? new Date(firmData.end_date) : new Date());

  const [openModal, setOpenModal] = useState(false);
  const [modalParam, setModalParam] = useState('');
  const [verim, setVerim] = useState('T0002');
  const {theme, setTheme} = useContext(ThemeContext);



  const [activeTab, setActiveTab] = useState(0);
  const [activeTabS, setActiveTabS] = useState(9);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const handleTabChangeS = (index) => {
    setActiveTabS(index);
  };



  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  const rule_detail_title = messages[currentLocale].rule_detail_title;
  const rule_id_title = messages[currentLocale].rule_id_title;
  const rule_class_title = messages[currentLocale].rule_class_title;
  const rule_class_name_title = messages[currentLocale].rule_class_name_title;
  const select_rule_type_hint = messages[currentLocale].select_rule_type_hint;
  const new_premises_btn = messages[currentLocale].new_premises_btn;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const update = messages[currentLocale].update;
  const new_rule_btn = messages[currentLocale].new_rule_btn;
  const premises_management_title = messages[currentLocale].premises_management_title;
  const rule_grp_id_title = messages[currentLocale].rule_grp_id_title;
  const rule_type_title = messages[currentLocale].rule_type_title;
  const detail = messages[currentLocale].detail;
  const start_date_title = messages[currentLocale].start_date_title;
  const end_date_title = messages[currentLocale].end_date_title;
  


  const { loading: defLoading, error: defError, data: defData } = useQuery(GET_RULES_CLS, {
    variables: {lang: currentLocale, defType: "RLSG", ruleClass2: varCode9 },
  });




  useEffect(() => {
    // newId değeri bağlamdaki yeni değeri yansıtır
    if (rulSubId !== '') {
      // newId güncellendiğinde setFirmCode işlevini çağırarak firmCode'u güncelliyor
    handleinser();  
    
    }
  }, [rulSubId, setRulSubnId]);


  useEffect(() => {
    if (defData && defData.tbl_gnl_def) {
      const rulesClasstems = defData.tbl_gnl_def.find(item => item.code === ruleType);
      if (rulesClasstems) {
        setRulesName(rulesClasstems.name);
      }
    }
  }, [ruleType, setRulesType, defData]);

  

  useEffect(() => {
    if (firmData) {

        
        setRulSubnId(firmData.id_seq);  
        setRulPernId(firmData.r_prn_id_seq);
        setRulesName(firmData.rules_sub_name);       
        setRulesType(firmData.rules_sub_type);
        setStartDate(new Date(firmData.start_date));
        setEndDate(new Date(firmData.end_date));
        setFmActive(firmData.active);
     
          
    }
  }, [firmData]);




  const handleUpdate = () => {
   
    
    updateRulesSub({
      variables: {
        rulPernId: rulPernId,
        rulSubId: rulSubId,
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,      
        rulesName: rulesName,        
        ruleType: ruleType,
        startDate: new Date(startDate).toLocaleDateString(),
        endDate: new Date(endDate).toLocaleDateString(),
        fmActive: fmActive,

        
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  const handleUpdateIdSeq = async () => {
    const requiredFields = ['rulesName', 'ruleType' ]; // Required fiels
    const customFieldNames = {
      rulesName: "Offer Name",
    //  ruleClass: "Rules Class",
      ruleType: "Rules Type",

    

    };
    const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
  
    if (emptyFields.length === 0) {
      try {
        const { data } = await updateIdSeq2({
          variables: {
            type: 'MFIRM', 
          },
        });
        const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
        console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
        setRulSubnId(updatedIdSeq); 
     //   setIdSeqTrg(updatedIdSeq);
        
        console.log(rulSubId);
        // setVarCode(updatedIdSeq.toString());  
      } catch (error) {
        console.error('Güncelleme hatası:', error);
      }
    } else {
      
      const emptyFieldsMessage = `Boş Alanları Doldurun: ${emptyFields.join(', ')}`;
     // console.log(emptyFieldsMessage);
      window.alert(emptyFieldsMessage);
    }
  };

  const getEmptyFields = (requiredFields, customFieldNames) => {
    const emptyFields = [];
  
    // Boş olan alanları bul
    for (const field of requiredFields) {
      if (!eval(field)) {
        emptyFields.push(customFieldNames[field]);
      }
    }
  
    return emptyFields;
  };

  const handleinser = () => {
    InsertSeason({
      variables: {

        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,
        rulPernId: varCode,
        rulSubId: rulSubId,        
        rulesName: rulesName,     
         ruleType: ruleType,     
      
        startDate: new Date(startDate).toLocaleDateString(),
        endDate: new Date(endDate).toLocaleDateString(),
        fmActive: fmActive
    
           
      },
    })
      .then(() => {
        window.alert("Rules insert successfully!");
        setVarCode8(rulSubId);
      })
      .catch((error) => {
        console.error("Error insert Rules:", error);
      });
  };


  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

      
  const onClick = () => {
    setVarCode11(ruleType); //EBO
    setVarCode8(rulSubId);
    setDisplayBasic(true);
    
  };

  const onClick2 = () => {
   // setVarCode10(0);  
    setVarCode11(ruleType); //EBO
    setVarCode10(0); //EBO
    setDisplayBasic(true);
    
  };
  
  const onHide = () => {
    setDisplayBasic(false);
    refetch();
  };


  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-sm"
      : "text-gray-500 font-bold text-sm";
  
    return (
      <div className={statusClass}>
      {rowData.active ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };


  const rulesClasstems = defData && defData.tbl_gnl_def
  ? defData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];






  return (

    <div className="container -mt-4 mx-auto sm:p-4 ">
      
  
   


         <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {rule_detail_title}
            </span>
          }
          className="ml-5 flex"
        >
      <div>

    
    <div className=" p-2 ">
         <div className="pt-1"> 
           <Fieldset>
             <p className="my-0  ">


      <div className="flex gap-4">
          <div className="w-1/6 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{rule_id_title}</label>
    <InputText className="w-full text-base" 
    id="username" value={rulSubId}
    onChange={(e) => setRulSubnId(e.target.value)}
    readOnly
    />
  </div>



  
  
  <div className="w-1/6 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{rule_class_title}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={ruleType} 
    onChange={(e) => setRulesType(e.target.value)} autoComplete="off"/>
    
  </div>

  <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {rule_class_name_title}
       </label>
       <Dropdown
       className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
        style={{ width: '244px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={ruleType}
         options={rulesClasstems}
         onChange={(e) => setRulesType(e.value)}
         placeholder={select_rule_type_hint}
         />
       </div>

      

  <div className=" w-2/6 flex-col font-medium  flex justify-content-center">  
  
  <label htmlFor="firmtype" 
  className=" flex-col  ml-0 mb-5 align-items-center block font-medium text-gray-950">{statusrec} </label><p></p>
  <div className="flex ml-0 flex-wrap gap-6">
  <div className="flex ml-0 align-items-center">
  <RadioButton inputId="ingredient1" name="active" value={true}  onChange={(e) => setFmActive(e.value)} checked={fmActive === true} />
          <label htmlFor="ingredient1" className="ml-2">{activerec}</label>
          
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient2" name="inactive" value={false}  onChange={(e) => setFmActive(e.value)} checked={fmActive === false} />
          <label htmlFor="ingredient2" className="ml-2">{inactiverec}</label>
      </div>
      </div>
      </div>  

  
 
  </div>

  
  <div className="flex gap-3 my-5">

  <div className="w-1/3 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Rule Description"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={rulesName} 
    onChange={(e) => setRulesName(e.target.value)} autoComplete="off"/>
    
  </div>

  <div className="w-1/3 h-10 gap-3">
        <label                
         htmlFor="firmname"> {start_date_title}</label>
        <Calendar className="w-full h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={startDate} dateFormat="dd/mm/yy"
        onChange={(e) => setStartDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>

      <div className="w-1/3 h-10 gap-3">
        <label                
         htmlFor="firmname"> {start_date_title}</label>
        <Calendar className="w-full h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={endDate} dateFormat="dd/mm/yy"
        onChange={(e) => setEndDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>
  
  
      </div>
      <div className="flex  gap-4 ">
      <div className="w-2/4">
     
  </div>
  <div className="w-2/4">
    <Button
      label={new_premises_btn}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={onClick2}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={update}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={handleUpdate}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={new_rule_btn}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
      onClick={handleUpdateIdSeq}
    />
  </div>
</div>

<div>
<Dialog visible={displayBasic} style={{ width: '55vw' }}header={premises_management_title} onHide={onHide}>
  <p>
   <HtlAgnOffPremises/>
  </p>
</Dialog>
</div>
</p>
   </Fieldset>
       </div>
 
       </div>          
  
  </div>


 <p> <DataTable
         value={data.tbl_rules_sub_premises }
         scrollable 
         scrollHeight="250px" loading={loading}
         stickyHeader
         stickyTopAt=".layout-topbar"
        

        >
           <Column field="id_seq"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Id"}</span>}
           style={{ textAlign: 'left', width: '6rem' }}
          >
          </Column>
          <Column field="r_prn_id_seq"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{rule_grp_id_title}</span>}
           style={{ textAlign: 'left', width: '6rem' }}
          >
          </Column>

          <Column field="rules_sub_type"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Code"}</span>}
           style={{ textAlign: 'left', width: '7rem' }}
          >
          </Column>
          <Column field="pre_type"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{rule_type_title}</span>}
           style={{ textAlign: 'left', width: '12rem' }}
          >
          </Column>

          <Column
           field="start_date"
           header={<span className="font-bold text-sm text-gray-900">{start_date_title}</span>}
           body={(rowData) => {
           const dateTimeString = rowData.start_date_v1;
           const dateObj = new Date(dateTimeString);
           const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
           const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)} `;
           

          return (
           <div className="text-sm">
           {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'left', width: '12rem' }}
           />

         
          <Column
           field="end_date"
           header={<span className="font-bold text-sm text-gray-900">{end_date_title}</span>}
           body={(rowData) => {
           const dateTimeString = rowData.end_date_v1;
           const dateObj = new Date(dateTimeString);
           const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
           const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)} `;
           // const createUser = rowData.end_date;

          return (
           <div className="text-sm">
           {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'left', width: '10rem' }}
           />

          <Column
          header={<span className="font-bold text-sm text-gray-900">{detail}</span>}
          body={(rowData) => (
            <button
              onClick={() => {               
                setVarCode10(rowData.id_seq);  
              //  setVarCode(rowData.sea_id_seq);                          
                onClick();
              
                
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable></p>    

              </TabPanel>
              <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Rule Premises"}
            </span>
          }
          className="ml-5 flex"
        >
    

              </TabPanel>
            
          </TabView>   
     
    </div>




    
    
    
 
 
);
};

export default HtlAgnOffresEdit;
